// extracted by mini-css-extract-plugin
export var about = "contact-info-module--about--hQG1g";
export var container = "contact-info-module--container--p2xU9";
export var inner = "contact-info-module--inner--yY5kU";
export var link = "contact-info-module--link--hzYHp";
export var linkmail = "contact-info-module--linkmail--TvHD9";
export var links = "contact-info-module--links--S2-TE";
export var logo = "contact-info-module--logo--f9gO+";
export var small = "contact-info-module--small--f32dX";
export var title = "contact-info-module--title--Ry8WL";